export default __webpack_public_path__ + "static/media/icon-reg-organization.563e32fe.svg";